(() => {
  if (window.__petalzProductPickerRepairLoaded) return;
  window.__petalzProductPickerRepairLoaded = true;

  const CATEGORY_HANDLES = new Set(['petalz-sativa', 'petalz-indica', 'petalz-hybrid']);
  const OPTION_NAMES = ['Strain', 'Size'];

  function productHandleFromPath(pathname) {
    const match = pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format((Number(cents) || 0) / 100);
  }

  function optionValue(variant, optionName) {
    return optionName === 'Strain' ? variant.option1 : variant.option2;
  }

  function selectedOptions(root) {
    return Object.fromEntries(
      OPTION_NAMES.map((name) => {
        const checked = root.querySelector(`input[type="radio"][data-petalz-live-option="${name}"]:checked`);
        return [name, checked?.value || ''];
      }),
    );
  }

  function selectedVariant(product, options) {
    return product.variants.find((variant) => {
      return OPTION_NAMES.every((name) => optionValue(variant, name) === options[name]);
    });
  }

  function updatePrice(productInfo, variant) {
    const priceRoot = productInfo.querySelector('[id^="price-"]');
    if (!priceRoot || !variant) return;

    const formatted = formatMoney(variant.price);
    priceRoot
      .querySelectorAll('.price-item--regular, .price-item--sale, .price-item--last')
      .forEach((node) => {
        node.textContent = formatted;
      });
  }

  function syncProductForm(productInfo, product, picker) {
    const options = selectedOptions(picker);
    const variant = selectedVariant(product, options);
    const forms = productInfo.querySelectorAll('form[data-type="add-to-cart-form"], form[id^="product-form-installment"]');
    const submitButton = productInfo.querySelector('[id^="ProductSubmitButton-"]');
    const submitText = submitButton?.querySelector('span');

    forms.forEach((form) => {
      const input = form.querySelector('input[name="id"]');
      if (!input) return;
      input.value = variant?.id || '';
      input.disabled = !variant?.available;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if (submitButton) {
      if (variant?.available) {
        submitButton.removeAttribute('disabled');
        submitButton.removeAttribute('aria-disabled');
        if (submitText && window.variantStrings?.addToCart) submitText.textContent = window.variantStrings.addToCart;
      } else {
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.setAttribute('aria-disabled', 'true');
        if (submitText) submitText.textContent = window.variantStrings?.soldOut || 'Sold out';
      }
    }

    updatePrice(productInfo, variant);

    if (variant?.id && productInfo.dataset.updateUrl !== 'false') {
      window.history.replaceState({}, '', `${productInfo.dataset.url}?variant=${variant.id}`);
    }

    productInfo.dispatchEvent(
      new CustomEvent('petalz:variant-change', {
        bubbles: true,
        detail: {
          product,
          variant,
          options,
        },
      }),
    );

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: productInfo.dataset.section,
          html: document,
          variant,
        },
      });
    }
  }

  function optionAvailable(product, optionName, value) {
    return product.variants.some((variant) => variant.available && optionValue(variant, optionName) === value);
  }

  function buildOptionFieldset(product, option, index, formId) {
    const fieldset = document.createElement('fieldset');
    fieldset.className = 'js product-form__input product-form__input--pill';

    const legend = document.createElement('legend');
    legend.className = 'form__label';
    legend.textContent = option.name;
    fieldset.appendChild(legend);

    option.values.forEach((value, valueIndex) => {
      const id = `petalz-live-${product.handle}-${index}-${valueIndex}`;
      const input = document.createElement('input');
      input.type = 'radio';
      input.id = id;
      input.name = `PetalzLive-${option.name}-${index}`;
      input.value = value;
      input.dataset.petalzLiveOption = option.name;
      if (formId) input.setAttribute('form', formId);
      if (valueIndex === 0) input.checked = true;
      if (!optionAvailable(product, option.name, value)) input.className = 'disabled';

      const label = document.createElement('label');
      label.setAttribute('for', id);
      label.textContent = value;

      fieldset.append(input, label);
    });

    return fieldset;
  }

  function renderPicker(productInfo, product) {
    const currentPicker = productInfo.querySelector('variant-selects');
    if (!currentPicker) return null;

    const form = productInfo.querySelector('form[data-type="add-to-cart-form"]');
    const repairPicker = document.createElement('div');
    repairPicker.className = 'petalz-live-variant-picker';
    repairPicker.dataset.petalzLiveVariantPicker = '';

    OPTION_NAMES.forEach((name, index) => {
      const option = product.options.find((candidate) => candidate.name === name);
      if (option) repairPicker.appendChild(buildOptionFieldset(product, option, index + 1, form?.id));
    });

    repairPicker.addEventListener('change', () => syncProductForm(productInfo, product, repairPicker));
    currentPicker.replaceWith(repairPicker);
    syncProductForm(productInfo, product, repairPicker);
    return repairPicker;
  }

  function currentPickerIsComplete(productInfo, product) {
    const dropdowns = productInfo.querySelectorAll('variant-selects select[name^="options["]');
    if (dropdowns.length >= OPTION_NAMES.length) return false;

    return OPTION_NAMES.every((name) => {
      const expected = product.options.find((option) => option.name === name)?.values || [];
      const actual = Array.from(
        productInfo.querySelectorAll(`variant-selects input[type="radio"][name^="${name}-"]`),
      ).map((input) => input.value);

      return expected.length > 0 && expected.length === actual.length && expected.every((value) => actual.includes(value));
    });
  }

  async function repairProductInfo(productInfo) {
    const handle = productHandleFromPath(productInfo.dataset.url || window.location.pathname);
    if (!CATEGORY_HANDLES.has(handle)) return;

    const response = await fetch(`/products/${handle}.js?petalz_picker_repair=${Date.now()}`, {
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
    });
    if (!response.ok) return;

    const product = await response.json();
    if (!currentPickerIsComplete(productInfo, product)) {
      renderPicker(productInfo, product);
    }
  }

  function init() {
    document.querySelectorAll('product-info[data-url]').forEach((productInfo) => {
      repairProductInfo(productInfo).catch(() => {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
